import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Navbar from "../webLayout/components/navbar/Navbar";
import WebHeader from "../webLayout/components/webHeader/WebHeader";
import WebFooter from "../../pages/components/home/webFooter/WebFooter";

const PagesLayout = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: isDarkMode
          ? "radial-gradient(circle at 82% 76%, #28302b 0%, #1A1D21 48%, #171a1d 100%)"
          : "radial-gradient(circle at 82% 78%, #e8ffdc 0%, #e4fff3 46%, #dffcf8 100%)",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Box
        component="header"
        sx={{
          position: "fixed",
          top: 0,
          left: { xs: 0, md: "4.7vw" },
          right: { xs: 0, md: "4.7vw" },
          zIndex: 1200,
          px: { xs: 1.5, md: 3 },
          pb: { xs: 1.25, md: 2 },
          backgroundColor: theme.palette.background.paper,
          borderRadius: { xs: 0, md: "0 0 42px 42px" },
          boxShadow:
            theme.palette.mode === "light"
              ? "0 10px 28px rgba(12, 65, 31, 0.08)"
              : "0 10px 28px rgba(0, 0, 0, 0.28)",
        }}
      >
        <WebHeader />
        <Navbar />
      </Box>

      <Box
        component="main"
        sx={{
          pt: { xs: "132px", md: "150px" },
          background: "transparent",
        }}
      >
        <Outlet />
      </Box>

      <WebFooter />
    </Box>
  );
};

export default PagesLayout;
